import DetailSOSPK from './DetailSOSPK';

export default DetailSOSPK